export default defineNuxtPlugin(async (nuxtApp) => {
    const { updateTranslation, setTranslations } = useTranslations();

    const i18n = nuxtApp.$i18n;

    setTranslations(useSettingsStore().translations);

    nuxtApp.$socket.on('translation_updated', (data) => {
        updateTranslation(data.key, data.text[i18n.locale.value]);
    });
})
